import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

// Choose the isolated preview before importing application providers, global
// styles, auth, payment SDKs or modules that can initialize network clients.
if (process.env.REACT_APP_STOREFRONT_COMMERCE_PROOF === 'true' && ['localhost', '127.0.0.1'].includes(window.location.hostname) && window.location.pathname === '/storefront-design/proof') {
  const StorefrontCommerceProof = React.lazy(() => import('./features/storefront-design/commerce/StorefrontCommerceProof'));
  ReactDOM.createRoot(document.getElementById('root')).render(<Suspense fallback={<main>Loading reference storefront…</main>}><StorefrontCommerceProof /></Suspense>);
} else if (window.location.pathname === '/storefront-design/preview') {
  const StorefrontPreviewRoute = React.lazy(() => import('./features/storefront-design/preview/StorefrontPreviewRoute'));
  ReactDOM.createRoot(document.getElementById('root')).render(
    <Suspense fallback={<main>Loading secure preview…</main>}>
      <StorefrontPreviewRoute />
    </Suspense>
  );
} else if (/^\/storefront-design\/live\/[a-z0-9-]+$/.test(window.location.pathname)) {
  const StorefrontPublishedRoute = React.lazy(() => import('./features/storefront-design/preview/StorefrontPublishedRoute'));
  ReactDOM.createRoot(document.getElementById('root')).render(
    <Suspense fallback={<main>Loading storefront…</main>}><StorefrontPublishedRoute /></Suspense>
  );
} else {
  import('./appBootstrap');
}
